/* eslint-disable no-console, no-constant-condition */

import React from "react";
import PropTypes from "prop-types";

class SearchboxWrapper extends React.Component {
  static defaultProps = {
    domAttributes: {}
  };

  static propTypes = {
    url: PropTypes.string.isRequired,
    domAttributes: PropTypes.object,
    checkinDate: PropTypes.string,
    checkoutDate: PropTypes.string
    // we may need to add more proptypes like onchangeDate onChangePax etc...
  };

  componentDidMount() {
    if (!this._globalSbox) {
      throw "Cannot find window.silverbyteDOM or window.silverbyteDOM.searchbox, did you forgot to include the searchbox script?";
    }
    this.mount();
  }

  componentDidUpdate(prevProps) {
    const { url, checkinDate, checkoutDate } = this.props;
    if (url !== prevProps.url) {
      this.mount();
    }
    if (
      checkinDate !== prevProps.checkinDate ||
      checkoutDate !== prevProps.checkoutDate
    ) {
      this.mount();
    }
  }

  componentWillUnmount() {
    this.unmount();
  }

  _globalSbox = window.silverbyteDOM && window.silverbyteDOM.searchbox;

  setSboxRef = ref => (this.sboxRef = ref);

  mount = () => {
    /*still not sure what is the best approach here (sagiv)
      1. we could pass all {...props} but it may cause extra renders for none relevant props.
      2. we could filter props like {url, domAttributes, ...rest} but we will need to remember adding new props to filter
      3. we could add a special prop like searchboxProps={key:value} then pass {...searchboxProps}
      4. we could explicit add props we care about but it can get tedious and we might miss some.
      -------
      for now i went with #2 because the API looks solid and i don't think we will add any new props.
    */
    const { url, domAttributes, ...rest } = this.props;
    this._globalSbox && this._globalSbox.mount(this.sboxRef, rest);
  };

  unmount = () => {
    this._globalSbox && this._globalSbox.unmount(this.sboxRef);
  };

  render() {
    const { url, domAttributes } = this.props;
    return (
      <div
        ref={this.setSboxRef}
        data-url={url}
        data-block-auto-render="true"
        {...domAttributes}
      />
    );
  }
}

export default SearchboxWrapper;

/* 
**** Example Usage *****
--------------------------------
<SearchboxWrapper
  domAttributes={{
    data-something: "some data"
  }}
  url={`http://localhost:8888/actionUrl?enabledRegionSelection=true&lang=${lang}&selectedOption.value=${hotel}`}
  onChangeCheckinDate={date => console.log(date)}
  onChangeCheckoutDate={date => console.log(date)}
/>

*/



// WEBPACK FOOTER //
// ./src/components/SearchboxWrapper/SearchboxWrapper.js